import React, { useContext } from 'react';
import { DefaultDropdownItem, DropdownSearchSelect } from '../../../../../../components/Dropdown';
import { TranslationKey } from '../../../../../../../types/translation/TranslationKey';
import { t } from '../../../../../../../types/translation/Translator';
import { ProductMasterDataContext } from '../../../../../../../context/ProductMasterDataContext';
import { HandlingUnitInput } from '../../../../../../../types/handling_unit/handlingUnit.input';
import { TextInput } from '../../../../../../components/TextInput';
import { HandlingUnitContext } from '../../../../../../../context/HandlingUnitContext';
import { Checkbox } from '../../../../../../components/Checkbox';

interface HandlingUnitInfoPaneProps {
  input: HandlingUnitInput;
  setInput: (hu: HandlingUnitInput) => void;
}

export default function HandlingUnitInfoPane({ input, setInput }: HandlingUnitInfoPaneProps) {
  const { productMasterData } = useContext(ProductMasterDataContext);
  const { handlingUnits } = useContext(HandlingUnitContext);

  const availableIds = new Set([...handlingUnits.values()].map(hu => hu.parentId));

  return (
    <div className='grid min-w-[400px] gap-4'>
      <DropdownSearchSelect
        mandatory
        label={t(TranslationKey.productMasterData).singular.upper}
        value={productMasterData.get(input.productMasterDataId)}
        items={[...productMasterData.values()]}
        onSelect={value => setInput(input.withProductMasterData(value?.id))}
        placeholder={t(TranslationKey.selectProductReference).singular.label}
        textBuilder={pmd => pmd.productName}
        itemBuilder={pmd => <DefaultDropdownItem text={pmd.productName} subtext={pmd.productNumber} />}
        searchBuilder={pmd => `${pmd.productName} - ${pmd.productNumber}`}
        disabled={!!input.id}
      />
      {input.productMasterDataId ? (
        <>
          <DropdownSearchSelect
            mandatory
            label={t(TranslationKey.handlingUnit).singular.upper}
            placeholder={t(TranslationKey.handlingUnit).singular.upper}
            value={productMasterData.get(input.parentId)}
            items={[...productMasterData.values()].filter(
              item => item.id !== input.productMasterDataId && item.handlingUnit && !availableIds.has(item.id),
            )}
            onSelect={value => setInput(input.withParent(value?.id))}
            textBuilder={pmd => pmd.productName}
            itemBuilder={pmd => <DefaultDropdownItem text={pmd.productName} subtext={pmd.productNumber} />}
            searchBuilder={pmd => `${pmd.productName} - ${pmd.productNumber}`}
            disabled={!!input.id}
          />
          <TextInput
            type={'number'}
            label={t(TranslationKey.quantity).singular.upper}
            placeholder={t(TranslationKey.quantity).singular.label}
            mandatory
            value={input.quantity}
            onChange={value => setInput(input.withQuantity(parseFloat(value)))}
          />
          <Checkbox
            value={input.default}
            label={t(TranslationKey.stockKeepingUnit).singular.label}
            onChange={value => setInput(input.withDefault(value))}
          />
        </>
      ) : null}
    </div>
  );
}
